import React, { useEffect, useRef, useState } from 'react';
import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, OverlayTrigger, Tooltip, InputGroup, Form } from 'react-bootstrap';

const PeriodeFilter = (props) => {

    const [periodeValue, setPeriodeValue] = useState("")
    const [libelle, setLibelle] = useState("")

    const inputDateStart = useRef("")
    const inputDateEnd = useRef("")

    useEffect(() => {
    }, [])

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-')
    }

    function changeDate(dateStart, dateEnd) {

        let dateStartAsDate = dateStart ? formatDate(new Date(dateStart)) : null
        let dateEndAsDate = dateEnd ? formatDate(new Date(dateEnd)) : null

        if ((!dateStartAsDate || dateStartAsDate?.split('-')[0] > 1970) && (!dateEndAsDate || dateEndAsDate?.split('-')[0] > 1970)) {
            props.onDateChange({
                'dateDebut': dateStartAsDate ? dateStartAsDate : null,
                'dateFin': dateEndAsDate ? dateEndAsDate : null
            })
            inputDateStart.current.value = dateStartAsDate ? dateStartAsDate : ""
            inputDateEnd.current.value = dateEndAsDate ? dateEndAsDate : ""
        }
    }

    function changePeriode(e) {

        setPeriodeValue(e.target.value)
        const today = new Date()

        if (e.target.value === "mois") {
            const firstActualMonthDay = new Date(today.getFullYear(), today.getMonth(), 1)
            const lastActualMonthDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)
            changeDate(firstActualMonthDay, lastActualMonthDay)
            const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
            setLibelle(` ${monthNames[today.getMonth()]} ${today.getFullYear()}`)
        }
        if (e.target.value === "annee") {
            const firstActualYearDay = new Date(today.getFullYear(), 0, 1)
            const lastActualYearDay = new Date(today.getFullYear(), 11, 31)
            changeDate(firstActualYearDay, lastActualYearDay)
            setLibelle(` ${today.getFullYear()}`)
        }
        if (e.target.value === "trimestre") {
            let firstActualTrimestreDay = null;
            let lastActualTrimestreDay = null;
            if (today.getMonth() <= 2) {
                firstActualTrimestreDay = new Date(today.getFullYear(), 0, 1)
                lastActualTrimestreDay = new Date(today.getFullYear(), 2, 31)
                setLibelle(`1er trimestre ${today.getFullYear()}`)
            } else if (today.getMonth() <= 5) {
                firstActualTrimestreDay = new Date(today.getFullYear(), 3, 1)
                lastActualTrimestreDay = new Date(today.getFullYear(), 5, 30)
                setLibelle(`2ème trimestre ${today.getFullYear()}`)
            } else if (today.getMonth() <= 8) {
                firstActualTrimestreDay = new Date(today.getFullYear(), 6, 1)
                lastActualTrimestreDay = new Date(today.getFullYear(), 8, 30)
                setLibelle(`3ème trimestre ${today.getFullYear()}`)
            } else {
                firstActualTrimestreDay = new Date(today.getFullYear(), 9, 1)
                lastActualTrimestreDay = new Date(today.getFullYear(), 11, 31)
                setLibelle(`4ème trimestre ${today.getFullYear()}`)
            }
            changeDate(firstActualTrimestreDay, lastActualTrimestreDay)
        }
        if (e.target.value === "") {
            setLibelle()
        }

    }

    function onDateChange(e) {

        let setDateStart = inputDateStart.current.value
        let setDateEnd = inputDateEnd.current.value

        if (e.target.name == "date-debut") {
            if (e.target.value) {
                setDateStart = e.target.value
            }else{
                setDateStart = null
            }
        }
        if (e.target.name == "date-fin") {
            if (e.target.value) {
                setDateEnd = e.target.value
            }else{
                setDateEnd = null
            }
        }

        props.onDateChange({
            'dateDebut': setDateStart,
            'dateFin': setDateEnd
        })

    }

    function prevNextPeriode(direction) {

        const currentStartDate = new Date(inputDateStart.current.value)

        if (direction === "positive") {
            if (periodeValue === "mois") {
                const nextStartDate = new Date(new Date(currentStartDate).setMonth(currentStartDate.getMonth() + 1))
                const nextEndDate = new Date(nextStartDate.getFullYear(), nextStartDate.getMonth() + 1, 0)
                changeDate(nextStartDate, nextEndDate)
                const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
                setLibelle(` ${monthNames[nextStartDate.getMonth()]} ${nextStartDate.getFullYear()}`)
            }
            if (periodeValue === "trimestre") {
                var nextStartDate = new Date(new Date(currentStartDate).setMonth(currentStartDate.getMonth() + 3));
                var nextEndDate = new Date(currentStartDate.setMonth(currentStartDate.getMonth() + 6))
                nextEndDate.setDate(nextEndDate.getDate() - 1);
                if (nextStartDate.getMonth() <= 2) {
                    setLibelle(`1er trimestre ${nextStartDate.getFullYear()}`)
                } else if (nextStartDate.getMonth() <= 5) {
                    setLibelle(`2ème trimestre ${nextStartDate.getFullYear()}`)
                } else if (nextStartDate.getMonth() <= 8) {
                    setLibelle(`3ème trimestre ${nextStartDate.getFullYear()}`)
                } else {
                    setLibelle(`4ème trimestre ${nextStartDate.getFullYear()}`)
                }
                changeDate(nextStartDate, nextEndDate)
            }
            if (periodeValue === "annee") {
                const nextStartDate = new Date(currentStartDate.getFullYear() + 1, 0, 1)
                const nextEndDate = new Date(currentStartDate.getFullYear() + 1, 11, 31)
                changeDate(nextStartDate, nextEndDate)
                setLibelle(` ${nextStartDate.getFullYear()}`)
            }
        }

        if (direction === "negative") {
            if (periodeValue === "mois") {
                const prevEndDate = new Date(new Date(currentStartDate).setDate(0))
                const prevStartDate = new Date(prevEndDate.getFullYear(), prevEndDate.getMonth(), 1)
                changeDate(prevStartDate, prevEndDate)
                const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
                setLibelle(` ${monthNames[prevStartDate.getMonth()]} ${prevStartDate.getFullYear()}`)
            }
            if (periodeValue === "trimestre") {
                var prevStartDate = new Date(new Date(currentStartDate).setMonth(currentStartDate.getMonth() - 3));
                var prevEndDate = new Date(currentStartDate.setMonth(currentStartDate.getMonth()))
                prevEndDate.setDate(prevEndDate.getDate() - 1);
                if (prevStartDate.getMonth() <= 2) {
                    setLibelle(`1er trimestre ${prevStartDate.getFullYear()}`)
                } else if (prevStartDate.getMonth() <= 5) {
                    setLibelle(`2ème trimestre ${prevStartDate.getFullYear()}`)
                } else if (prevStartDate.getMonth() <= 8) {
                    setLibelle(`3ème trimestre ${prevStartDate.getFullYear()}`)
                } else {
                    setLibelle(`4ème trimestre ${prevStartDate.getFullYear()}`)
                }
                changeDate(prevStartDate, prevEndDate)
            }
            if (periodeValue === "annee") {
                const prevStartDate = new Date(currentStartDate.getFullYear() - 1, 0, 1)
                const prevEndDate = new Date(currentStartDate.getFullYear() - 1, 11, 31)
                changeDate(prevStartDate, prevEndDate)
                setLibelle(` ${prevStartDate.getFullYear()}`)
            }
        }
    }

    function editPeriode() {
        setPeriodeValue("")
        setLibelle("")
    }

    function removeDates() {
        setPeriodeValue("")
        setLibelle("")
        props.onDateChange({
            'dateDebut': null,
            'dateFin': null
        })
        inputDateStart.current.value = ""
        inputDateEnd.current.value = ""
    }


    return (
        <div id="PeriodeFilter">
            <Row>
                <Col md={4}>
                    <p className="small mb-1">Filtrer par période</p>
                    <Form.Select size="sm" value={periodeValue} onChange={changePeriode}>
                        <option value="mois">Mois</option>
                        <option value="trimestre">Trimestre</option>
                        <option value="annee">Année</option>
                        <option value="">Personnalisée</option>
                    </Form.Select>
                </Col>

                <Col md={8}>
                    <p className="small mb-1">{libelle ? libelle : "Date de début / date de fin"}</p>
                    <InputGroup className="">
                        {periodeValue &&
                            <Button size="sm" variant="secondary" onClick={() => prevNextPeriode("negative")}>
                                <i className="material-icons">arrow_back_ios_new</i>
                            </Button>
                        }
                        <Form.Control
                            disabled={periodeValue}
                            size="sm"
                            ref={inputDateStart}
                            onChange={onDateChange}
                            name="date-debut"
                            placeholder="Date de début"
                            type="date"
                        />
                        <Form.Control
                            disabled={periodeValue}
                            size="sm"
                            ref={inputDateEnd}
                            onChange={onDateChange}
                            name="date-fin"
                            placeholder="Date de fin"
                            type="date"
                        />
                        {(periodeValue && (inputDateStart.current.value || inputDateEnd.current.value)) &&
                            <Button size="sm" variant="dark" onClick={() => editPeriode()}>
                                <i className="material-icons">edit</i>
                            </Button>
                        }
                        {(inputDateStart.current.value || inputDateEnd.current.value) &&
                            <Button size="sm" variant="danger" onClick={() => removeDates()}>
                                <i className="material-icons">close</i>
                            </Button>
                        }
                        {periodeValue &&
                            <Button size="sm" variant="secondary" onClick={() => prevNextPeriode("positive")}>
                                <i className="material-icons">arrow_forward_ios</i>
                            </Button>
                        }
                    </InputGroup>
                </Col>
            </Row>
        </div>
    )
}

export default PeriodeFilter;
